import { connect } from 'react-redux';
import { getEnabledFlagsList } from '../selectors';
import { setFlags } from '../actions';
var mapStateToProps = function (state) { return ({
    flags: getEnabledFlagsList(state),
}); };
var mapDispatchToProps = {
    setFlags: setFlags,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=FlagSwitcher.container.js.map